import CalendarIcon from '~/shared/assets/icons/calendar.svg';

interface DateDisplayInputProps {
  label: string;
  value: string;
  onCalendarClick: () => void;
}

export default function DateDisplayInput({ label, value, onCalendarClick }: DateDisplayInputProps) {
  return (
    <label className="flex min-w-72 flex-col gap-1">
      <span className="text-sm font-[600] font-family-inter text-primary-900">{label}</span>
      <div className="flex h-9 2xl:h-11 w-full items-center justify-between rounded-[8px] border border-gray-300 hover:border-primary-300 bg-white px-3 text-left cursor-pointer">
        <span className="text-sm text-primary-900">{value}</span>
        <button
          type="button"
          onClick={onCalendarClick}
          aria-label={`Open calendar for ${label}`}
          className="-mr-1 rounded p-1 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
        >
          <CalendarIcon className="size-6 stroke-[#2D2D32]" />
        </button>
      </div>
    </label>
  );
}
